import React, {useEffect, useState, useRef, useCallback} from "react";
import {GoogleMap,  Marker,  Polyline} from '@react-google-maps/api'

const containerStyle = {
    width: '100%',
    height: '425px'
};

const MapComponent = props => {
        const {
            zoom, origen, onDragOrigen, onDragDestination, destination, routes, mapClicked, dataCoords, showBounds,
            setZoom, center
        } = props

        const [map, setMap] = useState(null)

        const mapRef = useRef();

        const onMapLoad = useCallback((map) => {
            mapRef.current = map;
            setMap(map)
        }, []);

        const onUnmount = useCallback(function callback() {
            setMap(null)
        }, [])

        useEffect(() => {
            if (destination && origen && showBounds) {

                const bounds = new window.google.maps.LatLngBounds();

                const newOrigen = [{lat: origen[0], lng: origen[1]}]
                const newDestination = [{lat: destination[0], lng: destination[1]}]

                const newArray = [...newOrigen, ...newDestination]
                // eslint-disable-next-line array-callback-return
                newArray.map((cords) => {
                    bounds.extend(new window.google.maps.LatLng(cords.lat, cords.lng));

                });

                mapRef.current.fitBounds(bounds)

            } else {
                map && mapRef.current.setZoom(16);

            }
        }, [dataCoords, destination, origen, showBounds, zoom])

        const onIdle = () => {
            showBounds && setZoom(12)
        }

        return (
            <GoogleMap
                zoom={zoom}
                center={center}
                mapContainerStyle={containerStyle}
                onLoad={onMapLoad}
                onIdle={onIdle}
                onUnmount={onUnmount}
                onClick={ev => mapClicked(ev.latLng.lat(), ev.latLng.lng())}
            >
                {origen &&
                <Marker
                    draggable={true}
                    position={{lat: origen[0], lng: origen[1]}}
                    onDragEnd={ev => onDragOrigen(ev.latLng.lat(), ev.latLng.lng())}
                />}

                {destination && <Marker
                    draggable={true}
                    onDragEnd={ev => onDragDestination(ev.latLng.lat(), ev.latLng.lng())}
                    position={{lat: destination[0], lng: destination[1]}}/>}

                {routes &&
                <Polyline
                    path={routes}
                    geodesic={true}
                    options={{
                        strokeColor: "#0F75B3",
                        strokeOpacity: 0.75,
                        strokeWeight: 4,
                    }}/>
                }
            </GoogleMap>
        );
    }
;

export default MapComponent



